export enum enumShippingRole {
  SHIPPER,
  IMPORTER,
  OTHER,
  AGENT,
}
